import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from 'src/api/client';
import { Bank } from 'src/api/types';

interface BanksState {
  items: Bank[],
  error: string | null,
  loading: boolean,
  loaded: boolean
}

const initialState: BanksState = {
  items: [],
  error: null,
  loading: false,
  loaded: false
}

export const fetchBanks = createAsyncThunk('banks/fetchBanks',
  async (_, {rejectWithValue}) => {
    try {
      return apiClient.getBanks();
    }
    catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue('Unknown type of error occurred');
    }
  }
)

const banksSlice = createSlice({
  name: 'banks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchBanks.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchBanks.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload;
      state.loaded = true;
    })
    .addCase(fetchBanks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
  }
})

export default banksSlice.reducer;